import { PlatformPlan } from 'Generated/graphql-types'

export const plans = [
  {
    plan: PlatformPlan.Performance,
    name: 'Performance',
    // TODO: should query for this instead
    price: '$500',
    bullets: [
      'Collect individual and recurring donations; create unlimited campaigns.',
      'Access all capacity building templates, resources, & courses.',
      'Track unlimited impact metrics.',
      'Create unlimited stories.',
      'Invite unlimited users to collaborate and learn.',
    ],
  },
]
